import { User } from 'lucide-react';

interface TypingIndicatorProps {
  users: string[];
}

export function TypingIndicator({ users }: TypingIndicatorProps) {
  if (!users || users.length === 0) return null;

  return (
    <div className="px-6 py-2 flex items-center gap-3">
      <div className="flex-shrink-0 w-8 flex justify-center">
        <div className="h-8 w-8 rounded-full bg-black/20 flex items-center justify-center text-white text-xs font-bold shadow-sm">
          <User className="w-4 h-4 text-white/50" />
        </div>
      </div>

      <div className="bg-[#2A2B32] border border-white/5 px-4 py-3 rounded-2xl rounded-bl-[4px] w-fit flex items-center gap-1">
        <span className="flex h-1.5 w-1.5 animate-bounce rounded-full bg-muted-foreground/60 [animation-delay:-0.3s]" />
        <span className="flex h-1.5 w-1.5 animate-bounce rounded-full bg-muted-foreground/60 [animation-delay:-0.15s]" />
        <span className="flex h-1.5 w-1.5 animate-bounce rounded-full bg-muted-foreground/60" />
      </div>
    </div>
  );
}
